import React, { useContext, useEffect, useRef } from "react";
import HeroChild from "./HeroChild";
import Hero from "../Hero";
import Empty from "../Empty";
import TextChild from "../TextChild";
import { data } from "./data";
import Service from "../Service";
import Solutions from "../Solutions";
import "./index.css";
import { LandingsAnimationContext } from "../../../context/LandingsAnimationContext";
import Challenge from "../Challenge";
import AnimImg from "./anim/AnimImg";
import { animation, preAnimate, afterAnimate } from "./anim/animation";
import SolutionsChild from "./SolutionsChild";
import Carousel from "./Carousel";
import Phones from "./Phones";

const A2B = () => {
  const {
    isA2BAnimationFinished,
    setIsA2BAnimationFinished,
    isA2BAnimationStarted,
    setIsA2BAnimationStarted,
  } = useContext(LandingsAnimationContext);
  const ref = useRef(null);

  const options = {
    root: null,
    treshold: 0,
    rootMargin: "-150px",
  };

  const observer = new IntersectionObserver(function (entries, observer) {
    entries.forEach((entry) => {
      entry.target.classList.toggle("active", entry.isIntersecting);
    });
  }, options);

  useEffect(() => {
    const entry = document.querySelector(".a2b .empty__body svg");
    observer.observe(entry);
  }, []);

  return (
    <section className="a2b" ref={ref}>
      <Challenge
        heroTitle={data.hero.title}
        heroSubTitle={data.hero.subtitle}
        challengeTitle={data.challenge.title}
        sctRef={ref}
        animation={animation}
        preAnimate={preAnimate}
        afterAnimate={afterAnimate}
        isStarted={isA2BAnimationStarted}
        setIsStarted={setIsA2BAnimationStarted}
        isFinished={isA2BAnimationFinished}
        setIsFinished={setIsA2BAnimationFinished}
      >
        <AnimImg />
        <TextChild text={data.hero.text} />
        <TextChild text={data.challenge.text} />
      </Challenge>
      <Hero title={data.hero.title} subtitle={data.hero.subtitle}>
        <TextChild text={data.hero.text} />
        <HeroChild />
      </Hero>
      <Empty>
        <Phones />
      </Empty>
      <Solutions
        title={data.solutions.title}
        text={data.solutions.text}
        bgr={data.solutions.bgr}
        image={null}
        mod="solutions_light"
      >
        <SolutionsChild list={data.solutions.list} />
      </Solutions>
      <Solutions
        title={data.microservices.title}
        text={data.microservices.text}
        bgr={data.microservices.bgr}
        image={null}
        mod="microservices"
      >
        <Carousel slides={data.microservices.slides} />
      </Solutions>
      <Service
        image={data.service.image}
        widthBig="1360"
        heightBig="774"
        widthSmall="599"
        heightSmall="341"
        imageSmall={data.service.serviceSmall}
      />
    </section>
  );
};

export default A2B;
